import { useTranslation } from "react-i18next";

import Footer from "../../core/Footer";

const NotFoundPage = () => {
    const { t } = useTranslation('errors');

    return (
        <div className="height-100">
            <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                    alt="page not found"
                    src={`${process.env.PUBLIC_URL}/images/errors/not-found.svg`} />
                <h1 className="c-dark-blue fw-semi-bold">404 {t("page_not_found")}</h1>
                <div className="text-center w-75">
                    <span className="c-dark-blue">
                        {t("page_not_found_content")}
                    </span>
                </div>
            </div>
            <div className="footer-bottom">
                <Footer />
            </div>
        </div>);
}

export default NotFoundPage;